import React from 'react';
import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Rating from '@material-ui/lab/Rating';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"
import FilePicker from "composer/views/FilePicker.jsx"
import ContentMindMap from "composer/views/content/ContentMindMap.jsx"

import { TextField, Select, MenuItem, FormControl, InputLabel, Grid, Checkbox, FormControlLabel, Button, Icon, IconButton } from '@material-ui/core';
import { Card, CardHeader, CardContent } from '@material-ui/core';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';

import YouTube from "react-youtube";
var getYouTubeID = require("get-youtube-id");

var oneMB = 1024 * 1024;
var imageSizeLimit = 10 * oneMB;
var audioSizeLimit = 5 * oneMB;

const opts = {
  height: '300',
  width: '600',
  playerVars: {
    autoplay: 1,
  },
};

const opts2 = {
  height: 'window.innerHeight * 0.5',
  width: 'window.innerWidth * 0.39',
  playerVars: {
    autoplay: 1,
  },
};

class ContentDetailView extends React.Component {
  getContentCategory() {
    return [ Localization.strings.CATEGORY_NONE, Localization.strings.CATEGORY_KNOWLEDGE, Localization.strings.CATEGORY_EXPLORATION, Localization.strings.CATEGORY_EXPERIMENT, Localization.strings.CATEGORY_CREATION, Localization.strings.CATEGORY_EXPERIENCE ];
  }

  static TAG_OK = 0;
  static TAG_WARNING = 1;
  static TAG_ERROR = 2;

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      currentContent: null, //currentContent.kind <- tag type
      contentName: "",
      contentCategory: 0,
      contentDifficulty: 1,
      contentText: "",
      URLText:null,
      VideoId:null,
      contentPayload: null,
    };
    autoBind(this);

    let currentContent = this.props.parent.props.parent.getCurrentContent();
    if(currentContent) {
      this.state.currentContent = currentContent;
      this.state.contentName = currentContent.name;
      this.state.contentCategory = parseInt(currentContent.rationale);
      this.state.contentDifficulty = parseInt(currentContent.diff);
      this.state.contentText = currentContent.content;
      this.state.URLText = currentContent.URLText;
      this.state.VideoId = currentContent.VideoId;
      this.state.contentPayload = currentContent.payload;
    }
    else {
      this.state.currentContent = {};
      this.state.currentContent.kind = this.props.contentType;
      this.state.contentPayload = {};
      switch (this.state.currentContent.kind) {
        case Config.HOTSPOT_CONTENT_TABLE_AND_CELL:
          this.state.contentPayload.column_names = this.state.contentPayload.row_names = ",";
          break;
        case Config.HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI:
        case Config.HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI:
          this.state.contentPayload.correct0 = this.state.contentPayload.correct1 = this.state.contentPayload.correct2 = this.state.contentPayload.correct3 = false;
          break;
        default:
          break;
      }
    }
  }

  setPayload(payload) {
    this.setState({ contentPayload: payload });
    this.state.contentPayload = payload;
  }

  contentNameChanged(e) {
    this.setState({ contentName: e.target.value });
    this.state.contentName = e.target.value;
  }

  contentDifficultyChanged(e) {
    this.setState({ contentDifficulty: e.target.value });
    this.state.contentDifficulty = e.target.value;
  }

  contentCategoryChanged(e) {
    this.setState({ contentCategory: e.target.value });
    this.state.contentCategory = e.target.value;
  }

  videoPicker(title, instruction, extension="mp4", type="video"){
    return this.filePicker(title, instruction, extension, type);
  }

  imagePicker(title, instruction, extension="jpg,jpeg,png", type="image", path="", sizeLimit=imageSizeLimit, previewPath="", uploadID="", fileID="") {
    return this.filePicker(title, instruction, extension, type, path, sizeLimit, previewPath, uploadID, fileID);
  }

  audioPicker(title, instruction, extension="mp3", type="audio", path="", sizeLimit=audioSizeLimit, previewPath="", uploadID="", fileID="") {
    return this.filePicker(title, instruction, extension, type, path, sizeLimit, previewPath, uploadID, fileID);
  }

  filePicker(title, instruction, extension, type, path="", sizeLimit=oneMB, previewPath="", uploadID="", fileID="") {
    return (
      <FilePicker
        root={this.props.root}
        parent={this}
        allowedExtension={extension}
        pickerTitle={title}
        fileType={type}
        fileInstruction={instruction}
        onUploadSuccess={this.onUploadSuccess}
        onDeleteFile={this.onDeleteFile}
        onAbortUpload={this.onAbortUpload}
        filePath={path}
        previewPath={previewPath}
        sizeLimit={sizeLimit}
        uploadID={uploadID}
        fileID={fileID}
        epackID={this.props.root.getCurrentLocale().id}
      />
    );
  }

  onDeleteFile(fileID){
    switch(parseInt(this.state.currentContent.kind)){
      case Config.HOTSPOT_CONTENT_MC_OF_PICTURES:
        if (this.state.contentPayload.picture0.file_id == fileID){
          this.state.currentContent.picture0 = null;
        }
        if (this.state.contentPayload.picture1.file_id == fileID){
          this.state.currentContent.picture1 = null;
        }
        if (this.state.contentPayload.picture2.file_id == fileID){
          this.state.currentContent.picture2 = null;
        }
        if (this.state.contentPayload.picture3.file_id == fileID){
          this.state.currentContent.picture3 = null;
        }
        break;
      case Config.HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI:
        if (this.state.contentPayload.picture0.file_id == fileID){
          this.state.contentPayload.picture0 = null;
        }
        if (this.state.contentPayload.picture1.file_id == fileID){
          this.state.contentPayload.picture1 = null;
        }
        if (this.state.contentPayload.picture2.file_id == fileID){
          this.state.contentPayload.picture2 = null;
        }
        if (this.state.contentPayload.picture3.file_id == fileID){
          this.state.contentPayload.picture3 = null;
        }
        break;
      case Config.HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI:
        if (this.state.contentPayload.picture0.file_id == fileID){
          this.state.contentPayload.picture0 = null;
        }
        break;
      case Config.HOTSPOT_CONTENT_MC_OF_TEXTS:
          if (this.state.contentPayload.picture0.file_id == fileID){
            this.state.contentPayload.picture0 = null;
          }
        break;
      default:
        this.setState({ contentPayload: {} });
        this.state.contentPayload = {};
    }
  }

  onUploadSuccess(res) {
    let fileInfo = {
      ok: res['ok'],
      file_id: res['file_id'],
      display_name: res['display_name'],
      path: res['path'],
      tn_path: res['tn_path'],
      file_type: res['file_type'],
      file_size: res['file_size'],
      message: res['message'],
    };
    let uploadID = res['uploadID'];
    if (uploadID != "") {
      let payload = this.state.contentPayload;
      payload[uploadID] = fileInfo;
      this.setState({ contentPayload: payload });
      this.state.contentPayload = payload;
    }
  }

  onAbortUpload() {

  }

  contentTextChanged(e) {
    this.setState({ contentText: e.target.value });
    this.state.contentText = e.target.value;
  }

  contentText(title) {
    return (
      <Card style={{margin:"0 5px 10px 5px"}}>
        <CardHeader title={title} />
        <CardContent>
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            value={this.state.contentText}
            onChange={this.contentTextChanged}
            fullWidth
            multiline
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
        </CardContent>
      </Card>
    );
  }

  URLTextChanged(e) {
    this.state.contentPayload.URLText = e.target.value;
    this.state.contentPayload.VideoId = getYouTubeID(e.target.value);
    this.state.URLText = e.target.value;
    this.state.VideoId = getYouTubeID(e.target.value);
    this.setState({ URLText: e.target.value });
    this.setState({ VideoId: getYouTubeID(e.target.value)});
  }
  
  onLoad(e){
    if (this.state.contentPayload != null) {
      console.log("nnnn")
    }
  }

  URLText(title){
    let URLText, VideoId;
    if (this.state.contentPayload != null) {
      URLText = (this.state.contentPayload.URLText != null? this.state.contentPayload.URLText : "");
      VideoId = (this.state.contentPayload.VideoId != null? this.state.contentPayload.VideoId : "");
    }
    return (
      <Card style={{margin:"0 5px 20px 5px"}}>
        <CardHeader title={title} />
        <CardContent>
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            value={URLText}
            onChange={this.URLTextChanged}
            onLoad={this.onLoad}
            fullWidth
            multiline
          />
        </CardContent>
      <div style={{paddingLeft:window.innerWidth>=1346? 0:window.innerWidth*0.07}}>
      <YouTube videoId={VideoId} opts={window.innerWidth>=1346? opts:opts2} onReady = {this._onReady} >
      </YouTube>
      </div>
      </Card>
    );
  }

  _onReady(event) {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }

  fillInTheBlank() {
    if (parseInt(this.state.currentContent.kind) != Config.HOTSPOT_CONTENT_FILL_IN_THE_BLANK) {
        return;
    }

    let text1, text2;
    if (this.state.contentPayload != null) {
      text1 = (this.state.contentPayload.text1 != null? this.state.contentPayload.text1 : "");
      text2 = (this.state.contentPayload.text2 != null? this.state.contentPayload.text2 : "");
    }
    return (
      <Card style={{margin:"0 5px 10px 5px"}}>
        <CardContent>
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            label={Localization.strings.DESCRIPTION_FILL_IN_THE_BLANK_BEFORE}
            fullWidth
            multiline
            value={text1}
            onChange={this.textChanged('text1')}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            label={Localization.strings.DESCRIPTION_FILL_IN_THE_BLANK_AFTER}
            fullWidth
            multiline
            value={text2}
            onChange={this.textChanged('text2')}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
        </CardContent>
      </Card>
    );
  }

  mcText() {
    if (parseInt(this.state.currentContent.kind) != Config.HOTSPOT_CONTENT_MC_OF_TEXTS) {
        return;
    }

    let ans0, ans1, ans2, ans3;
    if (this.state.contentPayload != null) {
      ans0 = (this.state.contentPayload.ans0 != null? this.state.contentPayload.ans0 : "");
      ans1 = (this.state.contentPayload.ans1 != null? this.state.contentPayload.ans1 : "");
      ans2 = (this.state.contentPayload.ans2 != null? this.state.contentPayload.ans2 : "");
      ans3 = (this.state.contentPayload.ans3 != null? this.state.contentPayload.ans3 : "");
    }
    return [
      this.contentText(Localization.strings.DESCRIPTION_QUESTION),
      <Card style={{margin:"0 5px 10px 5px"}}>
        <CardContent>
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            label={Localization.strings.CHOICE+" 1 ("+Localization.strings.CORRECT_ANSWER+")"}
            fullWidth
            value={ans0}
            onChange={this.textChanged('ans0')}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            label={Localization.strings.CHOICE+" 2"}
            fullWidth
            value={ans1}
            onChange={this.textChanged('ans1')}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            label={Localization.strings.CHOICE+" 3"}
            fullWidth
            value={ans2}
            onChange={this.textChanged('ans2')}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            label={Localization.strings.CHOICE+" 4"}
            fullWidth
            value={ans3}
            onChange={this.textChanged('ans3')}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
        </CardContent>
      </Card>
    ];
  }

  textChanged = name => event => {
    let payload = this.state.contentPayload;
    payload[name] = event.target.value;
    this.setState({ contentPayload: payload });
    this.state.contentPayload = payload;
  }

  mcTextMulti() {
    if (parseInt(this.state.currentContent.kind) != Config.HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI) {
        return;
    }

    let ans0, ans1, ans2, ans3;
    let correct0, correct1, correct2, correct3;
    if (this.state.contentPayload != null) {
      ans0 = (this.state.contentPayload.ans0 != null? this.state.contentPayload.ans0 : "");
      ans1 = (this.state.contentPayload.ans1 != null? this.state.contentPayload.ans1 : "");
      ans2 = (this.state.contentPayload.ans2 != null? this.state.contentPayload.ans2 : "");
      ans3 = (this.state.contentPayload.ans3 != null? this.state.contentPayload.ans3 : "");
      correct0 = (this.state.contentPayload.correct0 != null? this.state.contentPayload.correct0 : false);
      correct1 = (this.state.contentPayload.correct0 != null? this.state.contentPayload.correct1 : false);
      correct2 = (this.state.contentPayload.correct0 != null? this.state.contentPayload.correct2 : false);
      correct3 = (this.state.contentPayload.correct0 != null? this.state.contentPayload.correct3 : false);
    }
    return [
      this.contentText(Localization.strings.DESCRIPTION_QUESTION),
      <Card style={{margin:"0 5px 10px 5px"}}>
        <CardContent>
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            label={Localization.strings.CHOICE+" 1"}
            fullWidth
            value={ans0}
            onChange={this.textChanged('ans0')}
            InputProps={{
              endAdornment:
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={correct0}
                      onChange={this.checkboxChanged('correct0')}
                    />
                  }
                  label={Localization.strings.CORRECT}
                />
            }}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            label={Localization.strings.CHOICE+" 2"}
            fullWidth
            value={ans1}
            onChange={this.textChanged('ans1')}
            InputProps={{
              endAdornment:
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={correct1}
                      onChange={this.checkboxChanged('correct1')}
                    />
                  }
                  label={Localization.strings.CORRECT}
                />
            }}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            label={Localization.strings.CHOICE+" 3"}
            fullWidth
            value={ans2}
            onChange={this.textChanged('ans2')}
            InputProps={{
              endAdornment:
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={correct2}
                      onChange={this.checkboxChanged('correct2')}
                    />
                  }
                  label={Localization.strings.CORRECT}
                />
            }}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
          <TextField
            margin="normal"
            size="small"
            variant="outlined"
            label={Localization.strings.CHOICE+" 4"}
            fullWidth
            value={ans3}
            onChange={this.textChanged('ans3')}
            InputProps={{
              endAdornment:
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={correct3}
                      onChange={this.checkboxChanged('correct3')}
                    />
                  }
                  label={Localization.strings.CORRECT}
                />
            }}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().CONTENT }}
          />
        </CardContent>
      </Card>
    ];
  }

  checkboxChanged = name => event => {
    let payload = this.state.contentPayload;
    payload[name] = event.target.checked;
    this.setState({ contentPayload: payload });
    this.state.contentPayload = payload;
  }

  mcPic() {
    if (parseInt(this.state.currentContent.kind) != Config.HOTSPOT_CONTENT_MC_OF_PICTURES) {
        return;
    }

    let path0, path1, path2, path3;
    let preview0, preview1, preview2, preview3;
    let file0_ID, file1_ID, file2_ID, file3_ID;

    if (this.state.currentContent.picture0 == null && this.state.contentPayload.picture0 != null){
      this.state.currentContent.picture0 = this.state.contentPayload.picture0;
    }
    if (this.state.currentContent.picture1 == null && this.state.contentPayload.picture1 != null){
      this.state.currentContent.picture1 = this.state.contentPayload.picture1;
    }
    if (this.state.currentContent.picture2 == null && this.state.contentPayload.picture2 != null){
      this.state.currentContent.picture2 = this.state.contentPayload.picture2;
    }
    if (this.state.currentContent.picture3 == null && this.state.contentPayload.picture3 != null){
      this.state.currentContent.picture3 = this.state.contentPayload.picture3;
    }
    
    path0 = (this.state.contentPayload.picture0 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture0.path : "");
    path1 = (this.state.contentPayload.picture1 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture1.path : "");
    path2 = (this.state.contentPayload.picture2 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture2.path : "");
    path3 = (this.state.contentPayload.picture3 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture3.path : "");
    preview0 = (this.state.contentPayload.picture0 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture0.tn_path : "");
    preview1 = (this.state.contentPayload.picture1 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture1.tn_path : "");
    preview2 = (this.state.contentPayload.picture2 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture2.tn_path : "");
    preview3 = (this.state.contentPayload.picture3 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture3.tn_path : "");
    file0_ID = (this.state.contentPayload.picture0 != null? this.state.contentPayload.picture0.file_id : "");
    file1_ID = (this.state.contentPayload.picture1 != null? this.state.contentPayload.picture1.file_id : "");
    file2_ID = (this.state.contentPayload.picture2 != null? this.state.contentPayload.picture2.file_id : "");
    file3_ID = (this.state.contentPayload.picture3 != null? this.state.contentPayload.picture3.file_id : "");
    
    return [
      <Grid item xs={12} sm={6}>
        {this.imagePicker(Localization.strings.CHOICE+" 1 ("+Localization.strings.CORRECT_ANSWER+")", "", "jpg,jpeg,png", "image", path0, imageSizeLimit, preview0, "picture0", file0_ID)}
      </Grid>,
      <Grid item xs={12} sm={6}>
        {this.imagePicker(Localization.strings.CHOICE+" 2", "", "jpg,jpeg,png", "image", path1, imageSizeLimit, preview1, "picture1", file1_ID)}
      </Grid>,
      <Grid item xs={12} sm={6}>
        {this.imagePicker(Localization.strings.CHOICE+" 3", "", "jpg,jpeg,png", "image", path2, imageSizeLimit, preview2, "picture2", file2_ID)}
      </Grid>,
      <Grid item xs={12} sm={6}>
        {this.imagePicker(Localization.strings.CHOICE+" 4", "", "jpg,jpeg,png", "image", path3, imageSizeLimit, preview3, "picture3", file3_ID)}
      </Grid>
    ];
  }

  mcPicMulti() {
    if (parseInt(this.state.currentContent.kind) != Config.HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI) {
        return;
    }

    let correct0, correct1, correct2, correct3;
    if (this.state.contentPayload != null) {
      correct0 = (this.state.contentPayload.correct0 != null? this.state.contentPayload.correct0 : false);
      correct1 = (this.state.contentPayload.correct0 != null? this.state.contentPayload.correct1 : false);
      correct2 = (this.state.contentPayload.correct0 != null? this.state.contentPayload.correct2 : false);
      correct3 = (this.state.contentPayload.correct0 != null? this.state.contentPayload.correct3 : false);
    }

    let path0, path1, path2, path3;
    let preview0, preview1, preview2, preview3;
    let file0_ID, file1_ID, file2_ID, file3_ID;
    path0 = (this.state.contentPayload.picture0 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture0.path : "");
    path1 = (this.state.contentPayload.picture1 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture1.path : "");
    path2 = (this.state.contentPayload.picture2 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture2.path : "");
    path3 = (this.state.contentPayload.picture3 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture3.path : "");
    preview0 = (this.state.contentPayload.picture0 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture0.tn_path : "");
    preview1 = (this.state.contentPayload.picture1 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture1.tn_path : "");
    preview2 = (this.state.contentPayload.picture2 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture2.tn_path : "");
    preview3 = (this.state.contentPayload.picture3 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture3.tn_path : "");
    file0_ID = (this.state.contentPayload.picture0 != null? this.state.contentPayload.picture0.file_id : "");
    file1_ID = (this.state.contentPayload.picture1 != null? this.state.contentPayload.picture1.file_id : "");
    file2_ID = (this.state.contentPayload.picture2 != null? this.state.contentPayload.picture2.file_id : "");
    file3_ID = (this.state.contentPayload.picture3 != null? this.state.contentPayload.picture3.file_id : "");

    return [
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={correct0}
              onChange={this.checkboxChanged('correct0')}
            />
          }
          label={Localization.strings.CORRECT}
        />
      {this.imagePicker(Localization.strings.CHOICE+" 1", "", "jpg,jpeg,png", "image", path0, imageSizeLimit, preview0, "picture0", file0_ID)}
      </Grid>,
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={correct1}
              onChange={this.checkboxChanged('correct1')}
            />
          }
          label={Localization.strings.CORRECT}
        />
      {this.imagePicker(Localization.strings.CHOICE+" 2", "", "jpg,jpeg,png", "image", path1, imageSizeLimit, preview1, "picture1", file1_ID)}
      </Grid>,
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={correct2}
              onChange={this.checkboxChanged('correct2')}
            />
          }
          label={Localization.strings.CORRECT}
        />
      {this.imagePicker(Localization.strings.CHOICE+" 3", "", "jpg,jpeg,png", "image", path2, imageSizeLimit, preview2, "picture2", file2_ID)}
      </Grid>,
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={correct3}
              onChange={this.checkboxChanged('correct3')}
            />
          }
          label={Localization.strings.CORRECT}
        />
      {this.imagePicker(Localization.strings.CHOICE+" 4", "", "jpg,jpeg,png", "image", path3, imageSizeLimit, preview3, "picture3", file3_ID)}
      </Grid>
    ];
  }

  tableAddColumnClicked() {
    let payload = this.state.contentPayload;
    if (payload.column_names.split(',').length < 6) {
      payload.column_names += ", ";
      this.setState({ contentPayload: payload });
      this.state.contentPayload = payload;
    }
  }

  tableAddRowClicked() {
    let payload = this.state.contentPayload;
    if (payload.row_names.split(',').length < 20) {
      payload.row_names += ", ";
      this.setState({ contentPayload: payload });
      this.state.contentPayload = payload;
    }
  }

  tableDeleteColumnClicked(index) {
    let column_names = "";
    let payload = this.state.contentPayload;
    let columns = payload.column_names.split(',');
    if (columns.length > 2) {
      for (let i = 0; i < columns.length; i++) {
        if (i != index) {
          column_names += ("," + columns[i]);
        }
      }
      column_names = column_names.substring(1);
      payload.column_names = column_names;
      this.setState({ contentPayload: payload });
      this.state.contentPayload = payload;
    }
  }

  tableDeleteRowClicked(index) {
    let row_names = "";
    let payload = this.state.contentPayload;
    let rows = payload.row_names.split(',');
    if (rows.length > 2) {
      for (let i = 0; i < rows.length; i++) {
        if (i != index) {
          row_names += ("," + rows[i]);
        }
      }
      row_names = row_names.substring(1);
      payload.row_names = row_names;
      this.setState({ contentPayload: payload });
      this.state.contentPayload = payload;
    }
  }

  tableColumnChanged = index => event => {
    console.log(event.target.value);
    let column_names = "";
    let payload = this.state.contentPayload;
    let columns = payload.column_names.split(',');
    for (let i = 0; i < columns.length; i++) {
      if (i != index) {
        column_names += ("," + columns[i]);
      }
      else {
        column_names += ("," + event.target.value.replace(/,/g, ''));
      }
    }
    column_names = column_names.substring(1);
    payload.column_names = column_names;
    this.setState({ contentPayload: payload });
    this.state.contentPayload = payload;
  }

  tableRowChanged = index => event => {
    let row_names = "";
    let payload = this.state.contentPayload;
    let rows = payload.row_names.split(',');
    for (let i = 0; i < rows.length; i++) {
      if (i != index) {
        row_names += ("," + rows[i]);
      }
      else {
        row_names += ("," + event.target.value.replace(/,/g, ''));
      }
    }
    row_names = row_names.substring(1);
    payload.row_names = row_names;
    this.setState({ contentPayload: payload });
    this.state.contentPayload = payload;
  }

  customTable() {
    if (parseInt(this.state.currentContent.kind) != Config.HOTSPOT_CONTENT_TABLE_AND_CELL) {
        return;
    }

    let columns=[], rows=[];
    if (this.state.contentPayload != null) {
      columns = (this.state.contentPayload.column_names != null? this.state.contentPayload.column_names.split(',') : []);
      rows = (this.state.contentPayload.row_names != null? this.state.contentPayload.row_names.split(',') : []);
    }
    return (
      <Table padding="normal" border="1%" bordercolor="#D3D3D3">
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            {
              columns.map( (column, i) => {
                return (
                  <TableCell key={i}>
                    <TextField
                      label={i+1}
                      value={column}
                      onChange={this.tableColumnChanged(i)}
                      InputProps={{
                        endAdornment: <IconButton onClick={() => this.tableDeleteColumnClicked(i)} disabled={columns.length <= 2}><Icon>delete</Icon></IconButton>
                      }}
                      inputProps={{ maxLength: Config.MAX_TEXT_LEN().NAME }}
                    />
                  </TableCell>
                )
              })
            }
            <TableCell>
              <Button
                onClick={this.tableAddColumnClicked}
                disabled={columns.length >= 6}
                variant="contained"
              >
                <Icon className="buttonIconLeft">add</Icon>
                {Localization.strings.COLUMN}
              </Button>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            rows.map( (row, i) => {
              return (
                <TableRow key={i}>
                  <TableCell>
                    <TextField
                      label={i+1}
                      value={row}
                      onChange={this.tableRowChanged(i)}
                      InputProps={{
                        endAdornment: <IconButton onClick={() => this.tableDeleteRowClicked(i)} disabled={rows.length <= 2}><Icon>delete</Icon></IconButton>
                      }}
                      inputProps={{ maxLength: Config.MAX_TEXT_LEN().NAME }}
                    />
                  </TableCell>
                  {
                    columns.map( (dummy, j) => {
                      return (
                        <TableCell key={j}/>
                      )
                    })
                  }
                </TableRow>
              )
            })
          }
          <TableRow>
            <TableCell>
              <Button
                onClick={this.tableAddRowClicked}
                disabled={rows.length >= 20}
                variant="contained"
              >
                <Icon className="buttonIconLeft">add</Icon>
                {Localization.strings.ROW}
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  checkEmptyContent(){
    let return_message = {
      //flag: 0: ok, 1: warning, 2: error
      flag: ContentDetailView.TAG_OK,
      message: ""
    }
    if (this.state.currentContent.kind){
      switch(parseInt(this.state.currentContent.kind)){
        case Config.HOTSPOT_CONTENT_SIMPLE_DESCRIPTION:
          if (this.state.contentText == "" && Object.keys(this.state.contentPayload).length == 0){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }else if (this.state.contentText == ""){
            return_message.flag = ContentDetailView.TAG_WARNING;
            return_message.message = Localization.strings.DESCRIPTION_NOT_FILLED;
          }else if (Object.keys(this.state.contentPayload).length == 0){
            return_message.flag = ContentDetailView.TAG_WARNING;
            return_message.message = Localization.strings.IMAGE_NOT_FILLED;
          }
          break;

        case Config.HOTSPOT_CONTENT_VOICE_OVER:
          if (this.state.contentText == "" && Object.keys(this.state.contentPayload).length == 0){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }else if (Object.keys(this.state.contentPayload).length == 0){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.VOICE_NOT_FILLED;
          }else if (this.state.contentText == ""){
            return_message.flag = ContentDetailView.TAG_WARNING;
            return_message.message = Localization.strings.DESCRIPTION_NOT_FILLED;
          }
          break;

        case Config.HOTSPOT_CONTENT_MOVIECLIP:
          console.log("this.state.URLText: " + this.state.URLText);
          if (this.state.contentText == "" && Object.keys(this.state.contentPayload).length == 0){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED; 
          }else if (this.state.contentText == ""){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.DESCRIPTION_NOT_FILLED;
          }else if(this.state.URLText == undefined){
            // do nothing
          }
          else if ((this.state.URLText == null || this.state.URLText == "") && (this.state.contentPayload.URLText ==null || this.state.contentPayload.URLText =="")) {
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.EMPTY_URL;
          }
          /*else if (this.state.URLText.length > 100){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.YOUTUBE_URL_TOO_LONG; 
          }*/
          else if (!this.state.URLText.includes("www.youtube.com/watch") && this.state.URLText != null ){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.ONLY_SUPPORT_VIDEO; 
          }
          else if(this.state.URLText != null && this.state.VideoId == null ){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.YOUTUBE_ID_INVALID; 
          }
          break;

        case Config.HOTSPOT_CONTENT_MC_OF_TEXTS:
          if (this.state.contentText == "" && Object.keys(this.state.contentPayload).length == 0){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }else if (this.state.contentText == ""){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.QUESTION_NOT_FILLED;
          }else if (!this.state.contentPayload.ans0 || this.state.contentPayload.ans0 == ""){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.CORRECT_ANSWER_CONTECT_NOT_FILLED;
          }else if (!this.state.contentPayload.picture0){
            return_message.flag = ContentDetailView.TAG_WARNING;
            return_message.message = Localization.strings.IMAGE_NOT_FILLED;
          }
          break;

        case Config.HOTSPOT_CONTENT_MC_OF_PICTURES:
          if (this.state.contentText == "" && Object.keys(this.state.contentPayload).length == 0){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }else if (this.state.contentText == ""){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.QUESTION_NOT_FILLED;
          }else if (!this.state.currentContent.picture0 || !this.state.currentContent.picture1 || !this.state.currentContent.picture2 || !this.state.currentContent.picture3){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.ANSWER_NOT_ALL_FILLED;
          }
          break;
          
        case Config.HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI:
          if (this.state.contentText == "" && !this.state.contentPayload.ans0 && !this.state.contentPayload.ans1 && !this.state.contentPayload.ans2 && !this.state.contentPayload.ans3){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }else if (this.state.contentText == ""){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.QUESTION_NOT_FILLED;
          }else if (
            (this.state.contentPayload.correct0 == true && (!this.state.contentPayload.ans0 || this.state.contentPayload.ans0 == "")) ||
            (this.state.contentPayload.correct1 == true && (!this.state.contentPayload.ans1 || this.state.contentPayload.ans1 == "")) ||
            (this.state.contentPayload.correct2 == true && (!this.state.contentPayload.ans2 || this.state.contentPayload.ans2 == "")) ||
            (this.state.contentPayload.correct3 == true && (!this.state.contentPayload.ans3 || this.state.contentPayload.ans3 == ""))
          ){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.CORRECT_ANSWER_CONTECT_NOT_FILLED;
          }else if(this.state.contentPayload.correct0 == false && this.state.contentPayload.correct1 == false && this.state.contentPayload.correct2 == false && this.state.contentPayload.correct3 == false){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.CORRECT_ANSWER_NOT_SELECTED;
          }else if (!this.state.contentPayload.picture0){
            return_message.flag = ContentDetailView.TAG_WARNING;
            return_message.message = Localization.strings.IMAGE_NOT_FILLED;
          }
          break;

        case Config.HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI:
          if (this.state.contentText == "" && !this.state.contentPayload.picture0 && !this.state.contentPayload.picture1 && !this.state.contentPayload.picture2 && !this.state.contentPayload.picture3){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }else if (this.state.contentText == ""){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.QUESTION_NOT_FILLED;
          }else if (
            (this.state.contentPayload.correct0 == true && (!this.state.contentPayload.picture0)) ||
            (this.state.contentPayload.correct1 == true && (!this.state.contentPayload.picture1)) ||
            (this.state.contentPayload.correct2 == true && (!this.state.contentPayload.picture2)) ||
            (this.state.contentPayload.correct3 == true && (!this.state.contentPayload.picture3))
          ){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.CORRECT_ANSWER_CONTECT_NOT_FILLED;
          }else if(this.state.contentPayload.correct0 == false && this.state.contentPayload.correct1 == false && this.state.contentPayload.correct2 == false && this.state.contentPayload.correct3 == false){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.CORRECT_ANSWER_NOT_SELECTED;
          }else if (!this.state.contentPayload.picture0 || !this.state.contentPayload.picture1 || !this.state.contentPayload.picture2 || !this.state.contentPayload.picture3){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.ANSWER_NOT_ALL_FILLED;
          }
          break;

        case Config.HOTSPOT_CONTENT_QUESTION:
          if (this.state.contentText == ""){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }
          break;

        case Config.HOTSPOT_CONTENT_FILL_IN_THE_BLANK:
          if ((this.state.contentPayload.text1 == "" && this.state.contentPayload.text2 == "") || Object.keys(this.state.contentPayload).length == 0){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.FILL_AT_LEAST_ONE;
          }else if (!this.state.contentPayload.picture0){
            return_message.flag = ContentDetailView.TAG_WARNING;
            return_message.message = Localization.strings.IMAGE_NOT_FILLED;
          }
          break;

        case Config.HOTSPOT_CONTENT_FILL_IN_MIND_MAP:
          if (Object.keys(this.state.contentPayload).length == 0){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }else if (this.state.contentPayload.linkList.length == 0 && this.state.contentPayload.boxList.length == 0){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }
          break;

        case Config.HOTSPOT_CONTENT_TAKE_PHOTO:
          if (this.state.contentText == ""){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }
          break;

        case Config.HOTSPOT_CONTENT_TABLE_AND_CELL:
          let row_OK = !(this.state.contentPayload.row_names.match(/^,/g) || this.state.contentPayload.row_names.match(/,$/g) || this.state.contentPayload.row_names.match(/,,/g));
          let col_OK = !(this.state.contentPayload.column_names.match(/^,/g) || this.state.contentPayload.column_names.match(/,$/g) || this.state.contentPayload.column_names.match(/,,/g));

          if (!row_OK || !col_OK){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.ROW_COL_NOT_FILLED;
          }
          break;

        case Config.HOTSPOT_CONTENT_TAKE_RECORD:
          if (this.state.contentText == ""){
            return_message.flag = ContentDetailView.TAG_ERROR;
            return_message.message = Localization.strings.NTH_FILLED;
          }
          break;
      }
    }
    return return_message;
  }

  render() {
    let preview0 = (this.state.contentPayload.picture0 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture0.tn_path : "");
    let path = (this.state.contentPayload.picture0 != null? Config.UPLOAD_PATH() + this.state.contentPayload.picture0.path : "");
    if (path == "") {
      path = (this.state.contentPayload.sound0 != null? Config.UPLOAD_PATH() + this.state.contentPayload.sound0.path : "");
    }
    let file_ID = (this.state.contentPayload.picture0 != null? this.state.contentPayload.picture0.file_id : "");
    if (file_ID == "") {
      file_ID = (this.state.contentPayload.sound0 != null? this.state.contentPayload.sound0.file_id : "");
    }
    return (
      <div>
        <Grid container spacing={2} alignItems='baseline'>
          <div style={{padding:"0 0 0 8px"}}>
            {Localization.strings.CONTENT_NAME}
          </div>
          <TextField
            style={{padding:"0 10px 0 10px"}}
            margin="normal"
            size="small"
            variant="outlined"
            value={this.state.contentName}
            onChange={this.contentNameChanged}
            inputProps={{ maxLength: Config.MAX_TEXT_LEN().NAME }}
          />
          <FormControl >
            <InputLabel>{Localization.strings.CATEGORY}</InputLabel>
            <Select
              value={this.state.contentCategory}
              onChange={this.contentCategoryChanged}
            >
              {this.getContentCategory().map((category, index) => {
                return (
                  <MenuItem key={index} value={index}>{category}</MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <div style={{padding:"0 10px"}}>
            {Localization.strings.DIFFICULTY}
          </div>
          <Rating style={{bottom:'-5px'}}
            value={this.state.contentDifficulty}
            max={5}
            onChange={this.contentDifficultyChanged}
          />
        </Grid>

        <If condition={this.state.currentContent != null}>
          <Then>
            <Grid container spacing={2} justify="center" style={{paddingTop:'10px'}}>
              <Switch condition={parseInt(this.state.currentContent.kind)}>
                <Case value={(Config.HOTSPOT_CONTENT_SIMPLE_DESCRIPTION)}>
                  <Grid item xs={12} sm={6}>
                    {this.imagePicker(Localization.strings.DESCRIPTION_IMAGE, "", "jpg,jpeg,png", "image", path, imageSizeLimit, preview0, "picture0", file_ID)}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {this.contentText(Localization.strings.DESCRIPTION_TEXT)}
                  </Grid>
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_VOICE_OVER)}>
                  <Grid item xs={12} sm={6}>
                    {this.audioPicker(Localization.strings.DESCRIPTION_AUDIO, "", "mp3", "audio", path, audioSizeLimit, "", "sound0", file_ID)}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {this.contentText(Localization.strings.DESCRIPTION_TEXT)}
                  </Grid>
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_MOVIECLIP)}>
                  <Grid item xs={12} sm={6}>
                  {this.URLText(Localization.strings.MOVIECLIP_URL)}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {this.contentText(Localization.strings.DESCRIPTION_TEXT)}
                  </Grid>
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_MC_OF_TEXTS)}>
                  <Grid item xs={12} sm={6}>
                    {this.imagePicker(Localization.strings.DESCRIPTION_IMAGE, "", "jpg,jpeg,png", "image", path, imageSizeLimit, preview0, "picture0", file_ID)}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {this.mcText()}
                  </Grid>
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_MC_OF_PICTURES)}>
                  <Grid item xs={12} >
                    {this.contentText(Localization.strings.DESCRIPTION_QUESTION)}
                  </Grid>
                  {this.mcPic()}
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI)}>
                  <Grid item xs={12} sm={6}>
                    {this.imagePicker(Localization.strings.DESCRIPTION_IMAGE, "", "jpg,jpeg,png", "image", path, imageSizeLimit, preview0, "picture0", file_ID)}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {this.mcTextMulti()}
                  </Grid>
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI)}>
                  <Grid item xs={12}>
                    {this.contentText(Localization.strings.DESCRIPTION_QUESTION)}
                  </Grid>
                  {this.mcPicMulti()}
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_QUESTION)}>
                  <Grid item xs={12}>
                    {this.contentText(Localization.strings.DESCRIPTION_QUESTION)}
                  </Grid>
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_FILL_IN_THE_BLANK)}>
                  <Grid item xs={12} sm={6}>
                    {this.imagePicker(Localization.strings.DESCRIPTION_IMAGE, "", "jpg,jpeg,png", "image", path, imageSizeLimit, preview0, "picture0", file_ID)}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {this.fillInTheBlank()}
                  </Grid>
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_FILL_IN_MIND_MAP)}>
                  <Grid item xs={12}>
                    <ContentMindMap root={this.props.root} parent={this} />
                  </Grid>
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_TAKE_PHOTO)}>
                  <Grid item xs={12}>
                    {this.contentText(Localization.strings.DESCRIPTION_TAKE_PHOTO)}
                  </Grid>
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_TABLE_AND_CELL)}>
                  <Grid item xs={12}>
                    {this.customTable()}
                  </Grid>
                </Case>
                <Case value={(Config.HOTSPOT_CONTENT_TAKE_RECORD)}>
                  <Grid item xs={12}>
                    {this.contentText(Localization.strings.DESCRIPTION_TAKE_RECORD)}
                  </Grid>
                </Case>
              </Switch>
            </Grid>
          </Then>
        </If>
      </div>
    )
  }
}

export default ContentDetailView;
